import { withStyles } from "@material-ui/core";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import React from "react";

export const customTabMuiStyle = {
  "&:hover": {
    color: "#333f4c",
    opacity: 1,
  },
  "&": {
    color: "#1A273A",
    fontWeight: 600,
    backgroundColor: "rgb(237 244 255)",
  },
};

export const CustomTabs = withStyles({
  root: {
    borderBottom: "none",
    "& .MuiTab-wrapper": {
      fontStyle: "normal",
      fontWeight: "700",
      fontSize: "14px",
      lineHeight: "20px",
    },
    "& .MuiTabs-indicator": {
      height: "3px",
    },
  },
  indicator: {
    backgroundColor: "#2563eb",
  },
  flexContainer: {
    borderBottom: "none",
  },
})(Tabs);

export const CustomTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    padding: "16px",
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: `24px`,
    color: "#808080",
    minWidth: "auto",
    position: "relative",
    borderBottom: "1px solid transparent",

    "&:hover": {
      color: "#0a0a29",
      opacity: 1,
    },
    "&$selected": {
      fontWeight: "bold",
      fontSize: "14px",
      lineHeight: "20px",
      padding: "16px 20px",
      color: "#2563eb",
      borderBottom: "3px solid #2563eb",
    },
  },
  selected: {},
}))((props) => <Tab disableRipple {...props} />);
